import { HttpResponse } from "@angular/common/http";
import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ReportEvaluationOpenProjectFiltersDTO } from "../../models/export-report.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export class ExportOpenProjectReportUseCase
  implements UseCase<ReportEvaluationOpenProjectFiltersDTO, HttpResponse<Blob>>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(filters: ReportEvaluationOpenProjectFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.repo.exportOpenProjectReport(filters);
  }
}

const exportOpenProjectReportUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new ExportOpenProjectReportUseCase(repo);

export const exportOpenProjectReportUseCaseProvider: Provider = {
  provide: ExportOpenProjectReportUseCase,
  useFactory: exportOpenProjectReportUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};